export default "__VITE_ASSET__D3UFk50w__"